/**
 * AdminRoute - Route guard for admin-only pages
 * Checks if the current user is in ADMIN_USER_IDS
 */
import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import FullScreenLoader from '../common/FullScreenLoader';
import adminService from '../../services/adminService';

const AdminRoute = ({ children }) => {
  const { isAuthenticated, loading: authLoading, firebaseUserId } = useAuth();
  const location = useLocation();
  const [isAdmin, setIsAdmin] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkAdmin = async () => {
      if (!isAuthenticated || !firebaseUserId) {
        setIsAdmin(false);
        setChecking(false);
        return;
      }

      try {
        const result = await adminService.checkAdminAccess();
        setIsAdmin(result.is_admin === true);
      } catch (error) {
        console.error('[AdminRoute] Error checking admin access:', error);
        setIsAdmin(false);
      } finally {
        setChecking(false);
      }
    };

    if (!authLoading) {
      checkAdmin();
    }
  }, [isAuthenticated, firebaseUserId, authLoading]);

  if (authLoading || checking) {
    return <FullScreenLoader message="Vérification des droits administrateur..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default AdminRoute;
